import React, { useCallback, useEffect, useState } from 'react';
import AddToBasketDialog from 'components/AddToBasket/AddToBasketDialog/AddToBasketDialog';
import DigitalDownloadDialog from 'components/DigitalDownloadDialog/DigitalDownloadDialog';
import { useSelectedSkuContext } from 'context/SelectedSku/SelectedSkuContext';
import { CheckItsRightDialog } from 'components/Insurance/InsuranceDialog/CheckItsRightDialog';
import { InsuranceOffer } from 'types/Product';
import styles from './DialogService.module.css';

const addToBasketRecsContainerId = 'recs-atb-container';

export function DialogService() {
  const {
    selectedSku,
    setSelectedInsurance,
    showCheckItsRightDialog,
    setCheckItsRightDialog,
    isAddToBasketDialogOpen,
    closeBasketDialog,
    handleContinueShopping,
    handleGoToBasket,
    recsDialogRef,
    recsAtbRef,
    isAddToBasketDialogRendered,
    isDigitalDownloadDialogRendered,
    handleDigitalDownloadAddToBasket,
    setIsDigitalDownloadDialogOpen,
    isDigitalDownloadDialogOpen,
    selectedInsurance,
    isCheckItsRightDialogRendered,
    selectedSkuInsuranceContent,
    showFindOutMore,
    setFindOutMore,
  } = useSelectedSkuContext();

  const [hasATBRecsCarousel, setHasATBRecsCarousel] = useState(false);

  const insuranceTitle = selectedSku?.insuranceOffers && selectedSku?.insuranceOffers[0]?.offer?.productDescription;
  const handleInsuranceOptionSelect = (option: InsuranceOffer | string | null) => {
    setSelectedInsurance(option);
    if (!showCheckItsRightDialog) {
      setCheckItsRightDialog(true);
    }
  };

  const handleNoInsuranceSelect = useCallback(() => {
    setTimeout(() => setSelectedInsurance('No insurance'), 200);
  }, []);

  const handleContinueWithoutInsurance = () => {
    handleNoInsuranceSelect();
    if (showFindOutMore) {
      setFindOutMore(false);
    }
    setCheckItsRightDialog(false);
  };

  const handleCheckItsRightClose = () => {
    setTimeout(() => {
      if (!showFindOutMore) {
        setSelectedInsurance(null);
      }
      setFindOutMore(false);
    }, 200);
    setCheckItsRightDialog(false);
  };

  const handleAddInsuranceButton = () => {
    if (showFindOutMore) {
      setFindOutMore(false);
    }
    setCheckItsRightDialog(false);
  };

  useEffect(() => {
    const esiNode = document.getElementById('esi-recs-atb');
    if (esiNode && recsAtbRef && 'current' in recsAtbRef && recsAtbRef.current) {
      recsAtbRef.current.appendChild(esiNode);
      esiNode.hidden = false;
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const atbRecsCarousel = document.querySelector('[data-testid="recommendations-carousel-add-to-basket"]');

      if (atbRecsCarousel) {
        setHasATBRecsCarousel(true);
        clearInterval(interval);
      }
    }, 500);

    const timeout = setTimeout(() => {
      clearInterval(interval);
    }, 15000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  useEffect(() => {
    if (
      isAddToBasketDialogOpen &&
      recsAtbRef &&
      'current' in recsAtbRef &&
      recsAtbRef.current &&
      recsDialogRef &&
      'current' in recsDialogRef &&
      recsDialogRef.current
    ) {
      recsDialogRef.current.appendChild(recsAtbRef.current);
      recsAtbRef.current.removeAttribute('hidden');
    }
  }, [isAddToBasketDialogOpen]);

  return (
    <>
      {selectedSku ? (
        <div className={styles.dialogServiceContainer}>
          {isCheckItsRightDialogRendered && insuranceTitle && selectedSkuInsuranceContent && (
            <CheckItsRightDialog
              title={insuranceTitle}
              options={selectedSku.insuranceOffers}
              onClose={handleCheckItsRightClose}
              selectedInsurance={selectedInsurance}
              open={showCheckItsRightDialog}
              handleSelectedInsurance={handleInsuranceOptionSelect}
              selectedSkuInsuranceContent={selectedSkuInsuranceContent}
              findOutMoreView={showFindOutMore}
              handleContinueWithoutInsurance={handleContinueWithoutInsurance}
              onAddInsuranceClick={handleAddInsuranceButton}
              selectedSku={selectedSku}
            />
          )}
          {isDigitalDownloadDialogRendered && (
            <DigitalDownloadDialog
              onClick={handleDigitalDownloadAddToBasket}
              onClose={() => setIsDigitalDownloadDialogOpen(false)}
              open={isDigitalDownloadDialogOpen}
            />
          )}
          {isAddToBasketDialogRendered && (
            <AddToBasketDialog
              open={isAddToBasketDialogOpen}
              onClose={closeBasketDialog}
              handleContinueShopping={handleContinueShopping}
              handleGoToBasket={handleGoToBasket}
              ref={recsDialogRef}
            />
          )}
        </div>
      ) : null}
      <div>
        <div
          ref={recsAtbRef}
          className={[
            styles.addToBasketRecsContainer,
            hasATBRecsCarousel ? styles.addToBasketRecsContainerHasCarousel : undefined,
          ]
            .filter(Boolean)
            .join(' ')}
          id={addToBasketRecsContainerId}
          data-testid="recs-atb"
          hidden
        />
      </div>
    </>
  );
}

export default DialogService;
